/**
 * O contexto que vai junto dos eventos do Sentry (monitoring.ts): quem está usando, em que mesa,
 * em que janela, e as quedas e voltas da conexão. Fica à parte porque lê a store, que só pode
 * carregar depois do Sentry ligado.
 */
import * as Sentry from '@sentry/react';
import { MONITORING, note, setMonitoringRoom, setMonitoringUser } from './monitoring.js';
import { useApp } from './store.js';
import { POPOUT } from './windowMode.js';

export function watchMonitoringContext(): void {
  if (!MONITORING) return;
  Sentry.setTag('window', POPOUT ? 'popout' : 'main');
  const sync = (state: ReturnType<typeof useApp.getState>, prev: ReturnType<typeof useApp.getState> | null) => {
    if (state.user?.id !== prev?.user?.id || state.user?.displayName !== prev?.user?.displayName) setMonitoringUser(state.user);
    if (state.room?.id !== prev?.room?.id || state.room?.name !== prev?.room?.name) {
      setMonitoringRoom(state.room ? { id: state.room.id, name: state.room.name } : null);
    }
    if (prev && state.status !== prev.status) note('websocket', state.status, state.status === 'offline' ? 'warning' : 'info');
  };
  sync(useApp.getState(), null);
  useApp.subscribe((state, prev) => sync(state, prev));
}
